var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFrame1618867793(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 184,
    height: 84,
    viewBox: "0 0 184 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 183,
    height: 83,
    rx: 7.5,
    stroke: "#D0D5DD"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_21031_57783)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113.875 31.6051C113.875 30.64 114.677 29.8571 115.667 29.8571H136.33C137.32 29.8571 138.122 30.64 138.122 31.6051V52.5099C138.122 53.4753 137.32 54.2578 136.33 54.2578H115.667C114.677 54.2578 113.875 53.4753 113.875 52.5099V31.6051Z",
    fill: "#006699"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.0039 50.2949H56.1228V46.9729H49.6658V34.2983H46.0039V50.2949Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.2459 50.2949V39.277H57.5837V50.2949H61.2459ZM59.4148 37.7726C60.6919 37.7726 61.4868 36.9265 61.4868 35.8685C61.463 34.7877 60.6919 33.9654 59.4392 33.9654C58.1863 33.9654 57.3672 34.7877 57.3672 35.8685C57.3672 36.9265 58.1619 37.7726 59.3909 37.7726H59.4148Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.9492 50.2949H66.6115V44.1419C66.6115 43.8126 66.6353 43.4836 66.7322 43.2482C66.9967 42.5905 67.5993 41.9091 68.611 41.9091C69.9364 41.9091 70.4665 42.9198 70.4665 44.4001V50.2949H74.1284V43.9772C74.1284 40.5929 72.3215 39.0181 69.912 39.0181C67.9365 39.0181 67.069 40.1224 66.5871 40.8746H66.6116V39.277H62.9493C62.9974 40.3109 62.9492 50.2949 62.9492 50.2949Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.2913 34.2983H75.6289V50.2949H79.2913V46.7228L80.2066 45.5706L83.0738 50.2949H87.579L82.7606 43.4555L86.9769 38.8023H82.568C82.568 38.8023 79.5564 42.9655 79.2913 43.4591V34.2983Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.3719 45.7006C97.42 45.4176 97.4925 44.8747 97.4925 44.2611C97.4925 41.4128 96.0466 38.5215 92.2401 38.5215C88.1682 38.5215 86.2891 41.7418 86.2891 44.6625C86.2891 48.275 88.5779 50.5312 92.5773 50.5312C94.1675 50.5312 95.637 50.2965 96.8418 49.8029L96.3598 47.3843C95.3721 47.712 94.3602 47.8756 93.1075 47.8756C91.3968 47.8756 89.9032 47.1737 89.7825 45.6771L97.3719 45.7V45.7006ZM89.7587 43.223C89.855 42.2827 90.4814 40.8957 92.0475 40.8957C93.7095 40.8957 94.0953 42.3769 94.0953 43.223H89.7587Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.531 34.2976V39.8351H106.482C105.952 39.0601 104.844 38.543 103.375 38.543C100.555 38.543 98.074 40.7992 98.0978 44.6533C98.0978 48.2261 100.339 50.5527 103.133 50.5527C104.651 50.5527 106.097 49.8945 106.819 48.6252H106.892L107.036 50.2942H110.289C110.241 49.5185 110.192 48.1788 110.192 46.8629V34.2976H106.531ZM106.531 45.1942C106.531 45.4759 106.506 45.7583 106.458 45.993C106.242 47.0038 105.374 47.7087 104.314 47.7087C102.796 47.7087 101.808 46.4867 101.808 44.5594C101.808 42.7499 102.652 41.2928 104.338 41.2928C105.47 41.2928 106.265 42.0681 106.482 43.0316C106.531 43.2435 106.531 43.4786 106.531 43.6899V45.1942Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M121.23 50.2812V39.263H117.568V50.2812H121.23ZM119.399 37.7586C120.676 37.7586 121.471 36.9125 121.471 35.8552C121.447 34.774 120.676 33.9514 119.423 33.9514C118.171 33.9514 117.352 34.774 117.352 35.8552C117.352 36.9125 118.146 37.7586 119.375 37.7586H119.399Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M123.258 50.2812H126.92V44.1282C126.92 43.7989 126.944 43.4699 127.041 43.2345C127.305 42.5765 127.908 41.8951 128.92 41.8951C130.245 41.8951 130.775 42.9055 130.775 44.3867V50.2812H134.437V43.9635C134.437 40.5792 132.63 39.0044 130.221 39.0044C128.245 39.0044 127.378 40.1087 126.896 40.8609H126.92V39.263H123.258C123.306 40.2969 123.258 50.2812 123.258 50.2812Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21031_57783"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 93.125,
    height: 25.4286,
    fill: "white",
    transform: "translate(45.4375 29.2852)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame1618867793);
export default __webpack_public_path__ + "static/media/Frame 1618867793.8f58574ef155b568f56d6d31136fb382.svg";
export { ForwardRef as ReactComponent };